import axios from 'axios';

export const setBillingAddressOnCart = async (cartId, token, address) => {
  let data = JSON.stringify({
    query: `mutation SetBillingAddressOnCart {
      setBillingAddressOnCart(
        input: {
          cart_id: "${cartId}"
          billing_address: {
            address: {
                firstname: "${address.firstname}"
                lastname: "${address.lastname}"
                company: ""
                street: ["${address.street}"]
                city: "${address.city}"
                region: "${address.region.region || address.region}"
                region_id: ${address.region.region_id || address.region_id}
                postcode: "${address.postcode}"
                country_code: "${address.country_code}"
                telephone: "${address.telephone}"
                save_in_address_book: false
            }
          }
        }
      ) {
        cart {
          billing_address {
            firstname
            lastname
            company
            street
            city
            region {
              code
              label
            }
            postcode
            telephone
            country {
              code
              label
            }
          }
        }
      }
    }`,
    variables: {}
  });

  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: 'https://mcstaging.candere.com/graphql',
    headers: { 
      'Content-Type': 'application/json', 
      'Authorization': `Bearer ${token}`
    },
    withCredentials: true,
    data: data
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error('Error setting billing address on cart:', error);
    throw error;
  }
};
